<div class="login_page">
  <div class="container-fluid">
    <div class="login-wrapper row">
      <div id="login" class="login loginpage col-lg-offset-4 col-md-offset-3 col-sm-offset-3 col-xs-offset-0 col-xs-12 col-sm-6 col-lg-4">
        <h1><a href="portal-login.html" title="Login Page" tabindex="-1">Portal Admin</a></h1>

        <div class="row">
          <h1 class="message"> {{Message}} </h1>
        </div>

        <p id="nav">
          <a routerLink="/login">Log in</a>
        </p>

      </div>
    </div>
  </div>
</div>
